import { useState, useEffect } from 'react'
import { Procedure } from '../types'
import { mockProcedures } from '../mockData'

interface UseProceduresListReturn {
  procedures: Procedure[]
  isLoading: boolean
  refetch: () => void
}

export const useProceduresList = (residentId: string): UseProceduresListReturn => {
  const [procedures, setProcedures] = useState<Procedure[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const fetchProcedures = () => {
    setIsLoading(true)
    // Simulate API call
    setTimeout(() => {
      // TODO: When backend is ready, filter by residentId
      // For now, return all mock procedures for testing
      setProcedures(mockProcedures)
      setIsLoading(false)
    }, 500)
  }

  useEffect(() => {
    fetchProcedures()
  }, [residentId])

  return {
    procedures,
    isLoading,
    refetch: fetchProcedures
  }
}
